import { FeatureFlagConfig } from "@fidelix/fx-miranda";

export const featureFlags = new FeatureFlagConfig({
  "Alarm Notification Configuration": ["dev", "localhost"],
  contacts: ["localhost"],
});
